export function computeScale(value: number, min: number, max: number) {
    const res = (value - min) / (max - min);
    return Math.max(0, Math.min(1, res));
}

